
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 32 32\" id=\"twitter-alt\" ><defs/><title>twitter-dk</title><g id=\"twitter-alt_Layer_2\" data-name=\"Layer 2\"><path class=\"cls-1\" d=\"M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm6.36 12.74v.42A9.34 9.34 0 0 1 8 21a6.93 6.93 0 0 0 .78 0 6.58 6.58 0 0 0 4.08-1.4 3.29 3.29 0 0 1-3.07-2.28 3.37 3.37 0 0 0 .62.06 3.31 3.31 0 0 0 .86-.12 3.29 3.29 0 0 1-2.63-3.22 3.28 3.28 0 0 0 1.49.41 3.29 3.29 0 0 1-1-4.38 9.32 9.32 0 0 0 6.77 3.43 3.29 3.29 0 0 1 5.59-3 6.55 6.55 0 0 0 2.08-.8 3.29 3.29 0 0 1-1.44 1.82A6.55 6.55 0 0 0 24 11a6.66 6.66 0 0 1-1.64 1.74z\" id=\"twitter-alt_Icons\"/></g></symbol>";
module.exports = sprite.add(image, "twitter-alt");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter-alt.svg
// module id = 667
// module chunks = 1474